import { literal, union } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Values = iotsUtils.makePartialRecordDecoder(
	constants.job.requirement.ids,
	union(literal(0), literal(1), literal(2), literal(3))
);
